import {Injectable} from '@angular/core';
import {AdminService} from '../../../../services/admin.service';
import {TreeNode} from 'primeng/primeng';
import {UserService} from '../../../../services/user.service';

@Injectable()
export class LearningService {

  public nodes: TreeNode[] = [];
  public nodeId = '';
  public nodeName = '';
  public nodeType = '';
  public nodeLevel = '';

  public noSpecializations = false;
  public getSpecializationsError = false;

  public testPassed = false;
  public testFailed = false;

  constructor(private adminService: AdminService,
              private userService: UserService) {
  }

  clearNodeSelection() {
    this.nodeId = '';
    this.nodeName = '';
    this.nodeType = '';
  }

  getLearningSpecs(id) {
    return this.adminService.getLearningSpecs(id);
  }

  getSingleSpec() {
    return this.adminService.getLearningSpecsUser(this.nodeId);
  }

  setNodes(value: TreeNode[]) {
    this.nodes = value;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/learning/service/learning.service.ts